export default __webpack_public_path__ + "static/media/Ballroll_00120.c9875d8f.png";